module.exports = __webpack_public_path__ + "static/twitter-ff7893b15037c40760e72ece49fcef45.svg";